import React from "react";
import { connect } from "react-redux";

import Select from "Components/common/Select/Select";
import Axios from "Source/axiosPool";
@connect(store => {
    return {
        loggedUser: store.loggedUser,
    }
})

class Account extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            list:[],
            selected:{},
            name:null,
            page:1,
            count:0
        }
        _.map(
            ["fetchAccountList","onRenderOption","handleClear","handleSearch","bottomContent","handleLoadMore"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }
    componentDidMount() {
        const {defaultSelected} = this.props
       // this.fetchAccountList()
      
        if(defaultSelected) {
            this.setState({selected:defaultSelected})
        }
    }
    componentDidUpdate(prev){
        const {timelog,defaultSelected } =this.props
        if(!_.isEqual(prev.timelog.selected.account,timelog.selected.account ) ) {
            if(!timelog.selected.account) {
                this.setState({selected:{}})
            } 
        }
        if(!_.isEqual(prev.defaultSelected,defaultSelected ) && defaultSelected) {
            this.setState({selected:defaultSelected})
        }
    }
        
   
    fetchAccountList() {
        const { loggedUser } = this.props
        const params={
            name:this.state.name,
            page:this.state.page
        }
        Axios.get('api/project/getUserProjectList', params).then(res => {
            if (res) {
                const newList = res.data.results.map(e=>{
                    return {
                            value: e.id,
                            label: e.project,
                            color: e.color
                    }
                })
                this.setState({ count: res.data.count, list: this.state.page < 2?newList:[...this.state.list, ...newList]  })
            }
        })
    }
  
    handleClear(){
        const{onChange}=this.props 
        if (onChange) {
            this.setState({selected:{}}, ()=>{
                onChange({ name: 'account', value: null })
            }) 
        }
           
    }

    onRenderOption( option ) {
        return (
            <div class="account-item">
                <div class="account-status" style={{backgroundColor: option.color}}></div>
                <div class="account-name">
                    <span>{ option.label.length > 22 ? `${option.label.substring(0, 22)}...` : option.label }</span>
                </div>
            </div>
        )
    }
    bottomContent() {
        return (<div >
            <p class="mb0 loadMoreContainer">
                <a onClick={this.handleLoadMore}>Load More</a>
            </p>

        </div>)
    }
    handleSearch(value){
        this.setState({ name: value, 
            page:1,}, () => {
            this.fetchAccountList()
            })
    }
    handleLoadMore() {
        this.setState({
            page:this.state.page +1}, () => {
            this.fetchAccountList()
            })
    }
    render() {
        const {list,selected} = this.state
        const { onChange,defaultSelected, defaultValue, optClasses=''} = this.props
        const onSelect = (e) => {  
            if (onChange) {
                this.setState({selected:e,name:null}, ()=>{
                    onChange({ name: 'account', value: e.value })
                })
              
            }
       }
       const optionList = _.orderBy(_.uniqBy([...defaultSelected?[defaultSelected]:[],...list],'value'),['label'],'asc')
        return (
            <div>
                {defaultValue ? <p class="defaultValue">{defaultValue}</p> :
                    <Select
                        isSearchable={true}
                        classes={{ options: `timelogSelectOptions ${optClasses}` }}
                        placeholder="Select Account"
                        options={optionList}
                        onChange={onSelect}
                        selected={selected}
                        onSearch={this.handleSearch}
                        onOpen={this.fetchAccountList}
                        onClearSelected={this.handleClear}
                        count={10}
                        isFirstItemSelected={false}
                        renderOption={this.onRenderOption}
                        bottomContent={this.state.count > optionList.length ?
                            <div >
                                <p class="mb0 loadMoreContainer">
                                    <a onClick={this.handleLoadMore}>Load More</a>
                                </p>

                            </div> : <div></div>}
                    />}
            </div>
         
        );
    }
}

export default Account;
